import { createJSONStorage } from "jotai/utils";

// prefix for storage keys
export const withPrefix = (key: string, prefix = "ogt:imap") =>
  `${prefix}:${key}`;

// Factory: per-tab (sessionStorage) JSON-storage with correct type
export const makeSessionJsonStorage = <T>() =>
  createJSONStorage<T>(() => sessionStorage);
